import { LegalLayout, Section } from "@/components/LegalLayout";
import { CONTACT } from "@/lib/site-data";

export default function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" testid="datenschutz-page">
      <Section title="1. Verantwortliche Stelle">
        <p>Ringel Fenstertechnik – Inhaber Andreas Ringel, Ostkamp 50, 59174 Kamen</p>
        <p>E-Mail: {CONTACT.email}</p>
      </Section>
      <Section title="2. Erhebung und Verarbeitung von Daten">
        <p>Beim Absenden des Kontaktformulars werden die von Ihnen angegebenen Daten (Name, E-Mail-Adresse, ggf. Telefonnummer und Nachricht) zur Bearbeitung Ihrer Anfrage verarbeitet (Art. 6 Abs. 1 lit. b DSGVO).</p>
      </Section>
      <Section title="3. Speicherdauer">
        <p>Ihre Daten werden nur so lange gespeichert, wie es für die Bearbeitung Ihrer Anfrage erforderlich ist, bzw. gesetzliche Aufbewahrungsfristen bestehen.</p>
      </Section>
      <Section title="4. Ihre Rechte">
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Wenden Sie sich hierzu an {CONTACT.email}.</p>
      </Section>
      <Section title="5. Beschwerderecht">
        <p>Sie haben das Recht, sich bei der zuständigen Datenschutz-Aufsichtsbehörde zu beschweren.</p>
      </Section>
    </LegalLayout>
  );
}
